import CostOfGoodsChart from './CostOfGoodsChart';

export default CostOfGoodsChart;
